import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const quotes = [
    {
        text: "I just turn it on and keep driving. It auto-accepts orders perfectly before anyone else can grab them. My daily earnings have shot up by 40%.",
        name: "Rajesh K.",
        role: "Captain · Bangalore",
        initials: "RK",
        testid: "testimonial-rajesh",
    },
    {
        text: "Best tool out there. I used to miss so many good rides because I was watching the road. Now the app literally clicks for me, instantly. Highly recommended!",
        name: "Venkat R.",
        role: "Captain · Chennai",
        initials: "VR",
        testid: "testimonial-venkat",
    },
];

export default function Testimonials() {
    return (
        <section id="captains" data-testid="testimonials-section" className="pb-16 md:pb-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <Reveal>
                    <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-brand">
                        Success stories
                    </p>
                    <h2 className="mt-4 font-display text-4xl font-bold tracking-tight text-ink md:text-6xl">
                        Captains love RapidClick.
                    </h2>
                </Reveal>

                <div className="mt-14 grid gap-6 md:grid-cols-2">
                    {quotes.map((q, i) => (
                        <Reveal key={q.name} delay={i * 0.12}>
                            <figure
                                data-testid={q.testid}
                                className="flex h-full flex-col rounded-2xl border border-line bg-white p-8 shadow-[0_8px_40px_-12px_rgba(0,0,0,0.05)] transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/30 md:p-10"
                            >
                                <div className="flex gap-1">
                                    {Array.from({ length: 5 }).map((_, s) => (
                                        <Star key={s} size={14} className="fill-brand text-brand" />
                                    ))}
                                </div>
                                <blockquote className="mt-6 flex-1 text-base leading-relaxed text-ink md:text-lg">
                                    “{q.text}”
                                </blockquote>
                                <figcaption className="mt-8 flex items-center gap-4">
                                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ink font-mono text-xs font-bold text-white">
                                        {q.initials}
                                    </span>
                                    <span>
                                        <span className="block text-sm font-bold text-ink">{q.name}</span>
                                        <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-mute">
                                            {q.role}
                                        </span>
                                    </span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
